<template>
  <div>
    <v-navigation-drawer
      :value="isAddNewFilaSidebarActive"
      temporary
      touchless
      :right="!$vuetify.rtl"
      :width="$vuetify.breakpoint.smAndUp ? 350 : '100%'"
      app
      @input="val => $emit('update:is-add-new-fila-sidebar-active', val)"
    >
      <v-card height="100%">
        <div class="drawer-header d-flex align-center mb-4">
          <span class="font-weight-semibold text-base text--primary">Criar Fila</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="$emit('update:is-add-new-fila-sidebar-active', false)"
          >
            <v-icon size="22">
              {{ icons.mdiClose }}
            </v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            @submit.prevent="onSubmit"
          >
            <v-text-field
              v-model="filaData.nome"
              outlined
              dense
              :rules="[validators.required]"
              label="Nome"
              placeholder="Nome"
              hide-details="auto"
              class="mb-6"
            ></v-text-field>

            <v-textarea
              v-model="filaData.descricao"
              outlined
              dense
              auto-grow
              label="Descrição"
              placeholder="Descrição"
              hint="Máximo de 300 caracteres"
              hide-details="auto"
              class="mb-6"
            ></v-textarea>

            <v-text-field
              v-model="filaData.maxTicketsPorAgente"
              label="Tickets máximos por agente"
              type="number"
              min="5"
              max="150"
              step="5"
              :rules="[validators.required, validators.between(filaData.maxTicketsPorAgente, 5, 150)]"
              outlined
              dense
              hide-details="auto"
              placeholder="Tickets máximos por agente"
              class="mb-6"
            >
            </v-text-field>

            <v-checkbox
              v-model="filaData.isAgrupado"
              label="Agrupar tickets desta fila?"
            ></v-checkbox>

            <v-checkbox
              v-model="filaData.permitirAgendamento"
              label="Permitir agendamento?"
            ></v-checkbox>

            <v-btn
              color="primary"
              class="me-3 mb-1"
              type="submit"
            >
              <v-progress-circular
                v-if="loadings"
                class="mx-6"
                indeterminate
                color="secundary"
              ></v-progress-circular>
              <span v-else> Criar </span>
            </v-btn>
            <v-btn
              color="secondary"
              class="mb-1"
              outlined
              type="reset"
              @click="resetFilaData"
            >
              Cancelar
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>

<script>
import {
  nameValidator,
  emailValidator,
  passwordValidator,
  required,
  select,

  between,
} from '@core/utils/validation'
import { mdiClose, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'
import { useRouter } from '@/@core/utils'
import { isTelefoneCelularValido, isCpfValido } from '@/utils/validation'
import FilaService from '@/services/modules/FilaService'

export default {
  model: {
    prop: 'isAddNewFilaSidebarActive',
    event: 'update:is-add-new-fila-sidebar-active',
  },
  props: {
    isAddNewFilaSidebarActive: {
      type: Boolean,
      required: true,
    },
  },

  data: () => ({
    loading: true,
  }),

  setup(props, { emit }) {

    const blankFilaData = {
      nome: '',
      descricao: '',
      maxTicketsPorAgente: 0,
      isAgrupado: false,
      permitirAgendamento: false,
    }

    const valid = ref(false)
    const form = ref(null)

    const loadings = ref(false)

    const validate = () => {
      form.value.validate()
    }

    const resetForm = () => {
      form.value.reset()
    }

    const filaData = ref(JSON.parse(JSON.stringify(blankFilaData)))
    const errorMsg = ref('Entre em contato com o servidor.')
    const resetFilaData = () => {
      filaData.value = JSON.parse(JSON.stringify(blankFilaData))
      resetForm()
      setTimeout(() => {
        emit('update:is-add-new-fila-sidebar-active', false)
      }, 2000)
    }

    const onSubmit = () => {
      loadings.value = !loadings.value
      if (valid.value) {
        FilaService
          .create(filaData.value)
          .then(() => {
            loadings.value = !loadings.value
            emit('refetch-data')
            resetFilaData()
          })
          .catch(() => {
            loadings.value = !loadings.value
          })
      } else {
        loadings.value = !loadings.value
        validate()
      }
    }

    return {
      resetFilaData,
      onSubmit,
      validate,
      form,
      filaData,
      valid,
      blankFilaData,
      loadings,
      errorMsg,

      // validation
      validators: {
        required,
        emailValidator,
        select,
        nameValidator,
        isCpfValido,
        passwordValidator,
        isTelefoneCelularValido,
        between,
      },
      icons: {
        mdiClose,
        mdiEyeOffOutline,
        mdiEyeOutline,
      },
    }
  },
}
</script>
